/* eslint-disable array-callback-return */
import React, { useEffect } from 'react';
import { Utils } from 'Utils/utils';
import { observer } from 'mobx-react';
import userDetail from 'Stores/userDetail';
import * as CONSTANTS from 'Utils/constants';
import CheckBox from 'Components/common/CheckBox';
import { companySearchState } from 'Stores/companySearch';
import advSearchState from 'Stores/advSearch';
import { confirmationPopupState } from 'Components/common/confirmationPopup';
import ToolTip from 'Components/common/ToolTip';
import { exportCompaniesState } from 'Components/common/exportCompanies/exportCompanies';
import Accordion from 'Components/common/accordion';
import InputWithButton from 'Components/common/inputWithButton';
import Button from 'Components/common/Button';
import { personalisedOnboardingState } from 'Stores/personalisedOnboardingState';

const {
  PERSONALIED_ONBOARDING_FLOWS,
  MX_PERSONALISED_ONBOARDING_EVENTS,
} = CONSTANTS;
const { TARGETED_ACCOUNTS, AD_AUDIENCE_LIST } = PERSONALIED_ONBOARDING_FLOWS;
const {
  LB_GOAL_CURRENT_STEP_VALUE,
  LB_GOAL_COMPLETE,
} = MX_PERSONALISED_ONBOARDING_EVENTS;
const { EXPORT, FIND_MATCHING_CONTACTS } = LB_GOAL_CURRENT_STEP_VALUE;

const CompanyExportComponent = observer(props => {
  const exportCompanyClick = () => {
    const {
      onboardingCurrentStep,
      isPersonalisedOnboardingFlow,
    } = personalisedOnboardingState;
    if (
      (isPersonalisedOnboardingFlow === TARGETED_ACCOUNTS ||
        isPersonalisedOnboardingFlow === AD_AUDIENCE_LIST) &&
      onboardingCurrentStep === 3
    ) {
      const eventName = Utils.personalisedOnboardingEventMap(
        isPersonalisedOnboardingFlow,
      );
      if (eventName) {
        Utils.mixpanelTrack(eventName, { currentStep: EXPORT });
        Utils.mixpanelTrack(LB_GOAL_COMPLETE, {
          goalName: eventName,
          currentStep: EXPORT,
        });
      }
      personalisedOnboardingState.setIsOnboardingGuideFlow(false);
      personalisedOnboardingState.clearOnboardingFlow();
    }
    if (
      companySearchState.bulkPurchaseIds.length ||
      companySearchState.hugeSelectionBulkIds.length
    ) {
      Utils.mixpanelTrack(CONSTANTS.MX_LB_EXPORT_EVENTS.LB_CLICK_EXPORT, {
        ...exportCompaniesState.exportMxData,
      });
      exportCompaniesState.setShowCrmExportOptions(true);
    }
  };

  return (
    <div
      className={`contact-action-btn adv-company-export${
        companySearchState.hugeSelectionBulkIds.length > 0 ||
        companySearchState.bulkPurchaseIds.length > 0
          ? ''
          : ' disabled'
      }`}
    >
      <div
        id="exportSelectedCompany"
        className="adv-company-export-wrapper "
        onClick={e => exportCompanyClick(e)}
      >
        Export
        <span className="ripple-effect" />
        {/* <i className="fa fa-angle-down dropdown-icon" /> */}
      </div>
    </div>
  );
});

const CompanyMiddleSection = observer(props => {
  const { contactId } = props;
  const [selectionClick, setSelectionClick] = React.useState(false);
  const [isAccordionOpen, setIsAccordionOpen] = React.useState(false);
  const [rangeBoxValue, setRangeBoxValue] = React.useState('');
  const [rangeBoxError, setRangeBoxError] = React.useState(false);

  const { featureFlags } = userDetail;
  const { COMPANY_CSV_EXPORT_INTERNAL = false } = featureFlags;

  const allowedMaxSelection =
    companySearchState.searchResultCount >
    companySearchState.maxSelectionAllowed
      ? companySearchState.maxSelectionAllowed
      : companySearchState.searchResultCount;

  useEffect(() => {
    if (!selectionClick) setIsAccordionOpen(false);
  }, [selectionClick]);

  const closeActionMask = () => {
    setSelectionClick(false);
  };

  const setSelectionClicked = e => {
    setSelectionClick(!selectionClick);
  };

  const selectAllInPage = e => {
    if (e !== null) e.stopPropagation();
    if (companySearchState.allContactSelected)
      companySearchState.updateSelectedBulkContactAll(true);
    else companySearchState.updateSelectedBulkContactAll();
    closeActionMask();
  };

  const clearSelections = e => {
    if (e !== null) e.stopPropagation();
    companySearchState.updateSelectedBulkContactAll(true);
    closeActionMask();
  };

  const rangeTextClick = e => {
    if (e !== null && e !== undefined) e.stopPropagation();
    if (document.getElementById('rangeInputBox') !== undefined)
      document.getElementById('rangeInputBox').focus();
  };

  const rangeSelection = e => {
    if (e !== null) e.stopPropagation();
    if (
      rangeBoxValue !== '' &&
      rangeBoxValue > 0 &&
      rangeBoxValue <= companySearchState.searchResultCount
    ) {
      companySearchState.selectHugeContacts(rangeBoxValue);
      setRangeBoxValue('');
      closeActionMask();
    } else {
      setRangeBoxError(true);
      rangeTextClick();
    }
  };

  const rangeSelectionInMaxLimitCase = value => {
    companySearchState.selectHugeContacts(value);
    closeActionMask();
  };

  const selectAllFromSearchResults = e => {
    if (e !== null) e.stopPropagation();
    if (
      companySearchState.searchResultCount >
      companySearchState.maxSelectionAllowed
    ) {
      // Currently it wont execute, check added in the calling flow
      Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_LIMIT_EXCEED_POPUP, {
        currentLimit: userDetail.userInfo.purchaseLimit,
        triedLimit: companySearchState.searchResultCount,
        btnSource: 'companyTab',
      });
      const emptyCbk = () => {};
      confirmationPopupState.setPopupValues({
        title: 'Limit Exceeded',
        content: `You can purchase a maximum of ${userDetail.userInfo.purchaseLimit} contacts in a single transaction.`,
        actionBtnText: 'OK',
        needCancelBtn: false,
        callback: emptyCbk,
      });
      confirmationPopupState.setShowPopup(true);
    } else {
      companySearchState.selectHugeContacts(
        companySearchState.searchResultCount,
        true,
      );
    }
    closeActionMask();
  };

  const rangeValueChange = e => {
    setRangeBoxError(false);
    if (e !== null) e.stopPropagation();
    if (e.charCode === 13) rangeSelection(e);
    else if (
      e.currentTarget &&
      e.currentTarget.value &&
      e.currentTarget.value <= allowedMaxSelection
    )
      // eslint-disable-next-line radix
      setRangeBoxValue(parseInt(e.currentTarget.value));
    else if (e.currentTarget.value === '') setRangeBoxValue('');
    else setRangeBoxValue(rangeBoxValue);
  };

  const findMatchingContacts = e => {
    const {
      onboardingCurrentStep,
      isPersonalisedOnboardingFlow,
    } = personalisedOnboardingState;
    if (
      isPersonalisedOnboardingFlow === TARGETED_ACCOUNTS &&
      onboardingCurrentStep === 3
    ) {
      const eventName = Utils.personalisedOnboardingEventMap(
        isPersonalisedOnboardingFlow,
      );
      if (eventName) {
        Utils.mixpanelTrack(eventName, { currentStep: FIND_MATCHING_CONTACTS });
        Utils.mixpanelTrack(LB_GOAL_COMPLETE, {
          goalName: eventName,
          currentStep: FIND_MATCHING_CONTACTS,
        });
      }
      personalisedOnboardingState.setIsOnboardingGuideFlow(false);
      personalisedOnboardingState.clearOnboardingFlow();
    }
    if (
      companySearchState.hugeSelectionDomain.length > 0 ||
      companySearchState.selectedCompanyDomain.length > 0
    ) {
      const companyPostData = {
        companyName:
          companySearchState.hugeSelectionDomain.length > 0
            ? companySearchState.hugeSelectionDomain
            : companySearchState.selectedCompanyDomain,
        limit: 50,
      };
      companySearchState.clearAllSelection();
      Utils.setLocalStorage('searchJson', companyPostData);
      Utils.setLocalStorage('companySearch', false);
      props.history.push('/advanced-search/contact#search');
      advSearchState.setCurrentPage(0, '', true);
      advSearchState.retainSearch();
      userDetail.setCurrentTab('contact');
    }
  };

  const formatNumberWithText = (number, text = '', showCompanyText = true) => {
    return number !== undefined && number !== null ? (
      <>
        {Utils.usNumberFormat(number)}
        &nbsp;{text}
        {showCompanyText && <>{number > 1 ? 'companies' : 'company'}&nbsp;</>}
      </>
    ) : (
      ''
    );
  };

  return companySearchState.searchResults.length > 0 ? (
    <>
      <div className="adv-leads-action">
        <div
          className={`adv-contact-action-btn-wrap${
            companySearchState.hugeSelectionBulkIds.length > 0 ||
            companySearchState.bulkPurchaseIds.length > 0
              ? ' contact-selected'
              : ''
          }`}
        >
          <div
            className={`contact-action-btn selection-wrap${
              selectionClick ? ' clicked' : ''
            }`}
          >
            <div
              className={`box-wrap${
                companySearchState.allContactSelected ? ' selected' : ''
              }`}
              onClick={setSelectionClicked}
            >
              <div className="contact-chechk-box-wrap">
                <CheckBox
                  dymamicClass={
                    companySearchState.allContactSelected ? 'selected' : ''
                  }
                  onClick={selectAllInPage}
                />
              </div>

              {(companySearchState.selectedAllContactAcrossPage ||
                companySearchState.selectedContactFromRange) && (
                <div className="selected-count">
                  &nbsp;
                  {formatNumberWithText(
                    companySearchState.hugeSelectionBulkIds.length,
                    '',
                    false,
                  )}{' '}
                  selected
                </div>
              )}

              {!companySearchState.selectedAllContactFromPage &&
                !companySearchState.selectedAllContactAcrossPage &&
                !companySearchState.selectedContactFromRange &&
                companySearchState.bulkPurchaseIds.length > 0 && (
                  <div className="selected-count">
                    &nbsp;
                    {formatNumberWithText(
                      companySearchState.bulkPurchaseIds.length,
                      '',
                      false,
                    )}{' '}
                    selected
                  </div>
                )}
              <i className="fa fa-angle-down dropdown-icon" />
            </div>
            <div className="drop-popup-box">
              <>
                {companySearchState.searchResultCount <
                companySearchState.maxSelectionAllowed ? (
                  <div
                    className="list-action-item select-all-across-page"
                    onClick={selectAllFromSearchResults}
                  >
                    Select all&nbsp;
                    {formatNumberWithText(
                      companySearchState.searchResultCount,
                      '',
                    )}
                  </div>
                ) : (
                  <div
                    className="list-action-item select-all-across-page"
                    onClick={e =>
                      rangeSelectionInMaxLimitCase(
                        companySearchState.maxSelectionAllowed,
                      )
                    }
                  >
                    Select top&nbsp;
                    {formatNumberWithText(
                      companySearchState.maxSelectionAllowed,
                      '',
                    )}
                  </div>
                )}
              </>
              <div className="list-action-item range-selection">
                <Accordion
                  title="Select top companies"
                  isAccordionOpen={isAccordionOpen}
                  setIsAccordionOpen={setIsAccordionOpen}
                >
                  <div className="range-selection-box">
                    <div>
                      You can select upto{' '}
                      {formatNumberWithText(allowedMaxSelection, '')}
                    </div>
                    <InputWithButton
                      inputProps={{
                        id: 'rangeInputBox',
                        min: 1,
                        step: 1,
                        max: allowedMaxSelection,
                        type: 'number',
                        value: rangeBoxValue,
                        placeholder: `upto ${allowedMaxSelection}`,
                        onChange: rangeValueChange,
                        onKeyPress: rangeValueChange,
                      }}
                      buttonProps={{
                        type: 'button',
                        btnText: 'Apply',
                        click: rangeSelection,
                      }}
                    />
                  </div>
                </Accordion>
              </div>
              {(companySearchState.hugeSelectionBulkIds > 0 ||
                companySearchState.bulkPurchaseIds.length > 0) && (
                <div className="list-action-item clear-selection">
                  <Button click={clearSelections} btnText="Clear Selection" />
                </div>
              )}
            </div>
          </div>
          <CompanyExportComponent />
          <div
            id="findMatchingContacts"
            className={`contact-action-btn find-matching-contacts toolTipParentWrap noDelay
              ${
                companySearchState.hugeSelectionBulkIds.length > 0 ||
                companySearchState.bulkPurchaseIds.length > 0
                  ? ' enabled'
                  : ''
              }`}
            onClick={e => findMatchingContacts(e)}
          >
            Find Matching Contacts
            <span className="ripple-effect" />
            <ToolTip toolTipText="Please select companies to find matching contacts" />
          </div>

          <div
            className={`bulk-action-mask${selectionClick ? ' show-mask' : ''}`}
            onClick={closeActionMask}
          />
        </div>
        {companySearchState.searchResultCount > 0 &&
          !companySearchState.resultLoading && (
            <div className="leads-count">
              {Utils.usNumberFormatForCompanyCount(
                companySearchState.searchResultCount,
              )}
              &nbsp;
              {companySearchState.searchResultCount > 1
                ? 'companies'
                : 'company'}{' '}
              found
            </div>
          )}
      </div>
    </>
  ) : (
    ''
  );
});

export default CompanyMiddleSection;
export { CompanyMiddleSection };
